import React from 'react';
import { 
  Phone, 
  CheckCircle, 
  XCircle, 
  PhoneMissed, 
  DollarSign 
} from 'lucide-react';

export const DashboardStatsView = ({ stats }) => {
  
  // Reusable Stat Card Component
  const StatCard = ({ title, value, icon: Icon, colorClass, bgClass }) => (
    <div className="bg-white dark:bg-slate-800 p-5 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 flex flex-col items-center justify-center text-center transition-all duration-300 hover:shadow-md hover:-translate-y-1">
      <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-3 ${bgClass}`}>
        <Icon size={24} className={colorClass} />
      </div>
      <h3 className="text-2xl font-bold text-slate-800 dark:text-white mb-1">
        {value}
      </h3>
      <p className="text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
        {title}
      </p>
    </div>
  );

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 w-full">
      
      {/* Total Calls */}
      <StatCard 
        title="Total Calls" 
        value={stats.totalCalls} 
        icon={Phone} 
        bgClass="bg-blue-50 dark:bg-blue-900/20"
        colorClass="text-blue-600 dark:text-blue-400"
      />

      {/* Answered Calls */}
      <StatCard 
        title="Answered" 
        value={stats.answeredCalls} 
        icon={CheckCircle} 
        bgClass="bg-sky-50 dark:bg-sky-900/20"
        colorClass="text-sky-600 dark:text-sky-400"
      />

      {/* Canceled Calls */}
      <StatCard 
        title="Canceled" 
        value={stats.cancelCalls} 
        icon={XCircle} 
        bgClass="bg-rose-50 dark:bg-rose-900/20"
        colorClass="text-rose-600 dark:text-rose-400"
      />

      {/* Missed Calls */}
      <StatCard 
        title="Missed" 
        value={stats.missCalls} 
        icon={PhoneMissed} 
        bgClass="bg-amber-50 dark:bg-amber-900/20"
        colorClass="text-amber-600 dark:text-amber-400"
      />

      {/* Total Profit */}
      <StatCard 
        title="Total Profit" 
        value={`$${stats.totalProfit.toFixed(2)}`} 
        icon={DollarSign} 
        bgClass="bg-emerald-50 dark:bg-emerald-900/20"
        colorClass="text-emerald-600 dark:text-emerald-400"
      />

    </div>
  );
};

export default DashboardStatsView;